import React from "react";
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ";

function FAQWrapper({ faqData }) {
  return (
    <FAQ
      data={faqData.faq}
      size={{}}
      theme="AIRASIA_CLASSIC"
      title={faqData.faq_title}
      titleMarginBottom="normal"
      titleType="h2"
    />
  );
}

export default FAQWrapper;
